const getCrumbs = (pathname: string): string[] => {
  const paths = pathname.split('/');
  let crumbs = [];

  for (var i = 1; i < paths.length; i++) {
    crumbs.push(
      `/${paths
        .slice(1, i + 1)
        .join('/')
        .toString()}`,
    );
  }

  return crumbs;
};

const StringHelper: { [key: string]: any } = {
  getCrumbs: getCrumbs,
};

export default StringHelper;
